import { PartialType, PickType } from '@nestjs/swagger';
import { BoardTypeDto } from './board-type.dto';
import { BoardTypeUpdatableInterface } from '../interfaces/board-type-updatable.interface';

export class BoardTypeUpdateDto
  extends PartialType(
    PickType(BoardTypeDto, [
      'name',
      'shortName',
      'description',
      'payableResourceTypes',
    ]),
  )
  implements BoardTypeUpdatableInterface {}
